import React, { useState,useEffect } from "react";
import Man3RoundedIcon from "@mui/icons-material/Man3Rounded";
import axios from "axios";
import Stack from "@mui/material/Stack";
import LinearProgress from "@mui/material/LinearProgress";
import {toast, ToastContainer} from "react-toastify";


const Addmembers = () => {
  const [loaderImage, setLoaderImage] = useState(false);
  const [inputField, setInputField] = useState({
    name: "",
    mobileNo: "",
    emailaddress:"",
    address: "",
    membership: "",
    profilePic:
      "https://static.vecteezy.com/system/resources/previews/011/490/381/original/happy-smiling-young-man-avatar-3d-portrait-of-a-man-cartoon-character-people-illustration-isolated-on-white-background-vector.jpg",
    joiningDate: "",
    personalComment: "",
  });
  const [membershipList, setMembershipList] = useState([]);
 const [selectedOption, setSelectedOption] = useState("");


 const handleOnChange = (event, name) => {
  const value = event.target.value;

  setInputField(prev => ({
    ...prev,
    [name]: value
  }));
};

  // const handleOnChange = (event, name) => {
  //   setInputField({ ...inputField, [name]: event.target.value });
  // };

  // const uploadImage = async (event) => {

  //   setLoaderImage(true);
  //   console.log("Image Uploading");
  //   const files = event.target.files;
  //   const data = new FormData();
  //   data.append("file", files[0]);

  //   data.append("upload_preset", "trego.in");
  //   try {
  //     const response = await axios.post(
  //       "https://api.cloudinary.com/v1_1/dvawsdzao/image/upload",
  //       data
  //     );
  //     // console.log(response);
  //     const imageUrl = response.data.url;
  //     setInputField({ ...inputField, ["profilePic"]: imageUrl });
  //     setLoaderImage(false);
  //   } catch (err) {
  //     console.log(err);
  //     setLoaderImage(false)
  //   }
  // };


  // ✅ FIXED IMAGE UPLOAD
  
  const uploadImage = async (event) => {
    setLoaderImage(true);

    const files = event.target.files;
    if (!files || files.length === 0) {
      setLoaderImage(false);
      return;
    }

    const data = new FormData();
    data.append("file", files[0]);
    data.append("upload_preset", "trego.in");

    try {
      const response = await axios.post(
        "https://api.cloudinary.com/v1_1/dvawsdzao/image/upload",
        data,
        {
          withCredentials: false, // 🔥 IMPORTANT FIX
        }
      );

      const imageUrl = response.data.secure_url;

      setInputField((prev) => ({
        ...prev,
        profilePic: imageUrl,
      }));

      setLoaderImage(false);
      // toast.success("Image uploaded ✅");

    } catch (err) {
      setLoaderImage(false);
      toast.error("Image upload failed ❌");
    }
  };


const fetchMembership = async()=>{
await axios.get(`${process.env.REACT_APP_FRONTEND_URL}/plans/get-membership`,{withCredentials:true}).then((response)=>{
setMembershipList(response.data.membership);
if(response.data.membership.length===0){
  return toast.error("No any membership added yet");
}else{
let a = response.data.membership[0]._id;
setSelectedOption(a);
// setInputField({...inputField, membership:a});
setInputField(prev => ({
  ...prev,
  membership: a
}));
}
}).catch(err=>{
toast.error("Something Wrong Happened");
})
}


useEffect(()=>{
  console.log(inputField);
  fetchMembership();
},[]);

const handleOnChangeSelect = (event)=>{
  let value = event.target.value;
  setSelectedOption(value);
  // setInputField({...inputField, membership:value});
    setInputField(prev => ({
  ...prev,
  membership: value
}));
}

const handleRegisterButton=async()=>{
  await axios.post(`${process.env.REACT_APP_FRONTEND_URL}/members/register-member`,inputField,{withCredentials:true}).then((response)=>{
   toast.success("Added Successfully");
   setTimeout(()=>{
    window.location.reload();
   },500)
  }).catch(err=>{
toast.error("Something Wrong Happened");
})
}


  return (
    <div>
      <div className="addmembers1">
        <input
          value={inputField.name}
          onChange={(event) => {
            handleOnChange(event, "name");
          }}
          placeholder="Name of the Joinee"
          type="text"
          className="addmembers1In"
        />
        <input
          value={inputField.mobileNo}
          onChange={(event) => {
            handleOnChange(event, "mobileNo");
          }}
          placeholder="Mobile No..."
          type="text"
          className="addmembers1In"
        />

        {/* email option */}
        <input
          value={inputField.emailaddress}
          onChange={(event) => {
            handleOnChange(event, "emailaddress");
          }}
          placeholder="Enter email"
          type="email"
          className="addmembers1In"
        />

        <input
          value={inputField.address}
          onChange={(event) => {
            handleOnChange(event, "address");
          }}
          placeholder="Enter Address"
          type="text"
          className="addmembers1In"
        />

        {/* personal Comment */}
        <input
          value={inputField.personalComment}
          onChange={(event) => {
            handleOnChange(event, "personalComment");
          }}
          placeholder="Personal Comment"
          type="text"
          className="addmembers1In"
        />

        <input
          value={inputField.joiningDate}
          onChange={(event) => {
            handleOnChange(event, "joiningDate");
          }}
          type="date"
          className="addmembers1In"
        />

        <select value={selectedOption} onChange={handleOnChangeSelect} className="addmembers1In">
        {
        membershipList.map((item, index)=>{
          return(
            <option key={index} value={item._id}> {item.months} Months Membership</option>
          );
        })
        }
        </select>



        <input type="file" onChange={uploadImage} />

        <div className="addmembers1Img">
          {loaderImage ? (
            // <Stack sx={{ width: "100%" }}>
            //   <LinearProgress color="secondary" />
            // </Stack>
             <div className="loader"></div> 
          ) : (
  <img className="addmembers1Imgg" src={inputField.profilePic} alt="profile" />   
)}

          {/* <img className="addmembers1Imgg" src={inputField.profilePic} alt="profile" /> */}
        </div>

        {/* <input type="file" onChange={(e) => uploadImage(e)} />

        <div className="addmembers1Img">

{ 
     loaderImage && <Stack  sx={{ width: "100%", color: "grey.500" }} spacing={2}>
        <LinearProgress color="secondary" />
      </Stack>}

          <img className="addmembers1Imgg" src={inputField.profilePic} />
        </div> */}

        <div onClick={()=>handleRegisterButton()} className="btn blue addmemreg">ADD New Members</div>
      </div>
      <ToastContainer/>
    </div>
  );
};

export default Addmembers;
